import $ from 'jquery';
import scrollama from 'scrollama';
import { throttle } from 'throttle-debounce';

export const scrollingCheckerboard = {
    setupScrollingCheckerboard: () => {
        let scrollableCheckerboards = document.querySelectorAll('.cl-scrolling-checkerboard');

        if (!scrollableCheckerboards.length) {
            return;
        }

        scrollableCheckerboards.forEach((checkerboard, i) => {
            let checkerboardGraphic = checkerboard.querySelector('.cl-scrolling-checkerboard__graphic');
            let checkerboardSteps = checkerboard.querySelectorAll('.cl-scrolling-checkerboard__step-wrap');
            let checkerboardMediaEls = checkerboard.querySelectorAll('.js-ch-media');
            let bullets = checkerboard.querySelector('.js-scrolling-checkerboard-bullets');

            checkerboardMediaEls.forEach((mediaEl, index) => {
                if (index === 0) {
                    mediaEl.classList.add('is-active');
                }
            });

            let handleResize = () => {
                let stepH = Math.floor(window.innerHeight * 0.75);

                checkerboardSteps.forEach((step) => {
                    step.style.height = `${stepH}px`;
                });

                checkerboardGraphic.setAttribute('style', `top: ${(window.innerHeight + document.querySelector('header').offsetHeight - checkerboardGraphic.offsetHeight) / 2}px`);
                bullets.setAttribute('style', `top: ${(window.innerHeight - checkerboardGraphic.offsetHeight) / 2}px`);

                window['scroller' + i].resize();
            };

            let handleStepEnter = (response) => {
                checkerboardMediaEls.forEach((mediaEl, i) => {
                    mediaEl.classList.remove('is-active');

                    if (i === response.index) {
                        mediaEl.classList.add('is-active');
                        let activeBullet = $(`.cl-scrolling-checkerboard__bullet:nth-child(${response.index + 1})`);
                        activeBullet.addClass('state-active');
                    } else {
                        $('.cl-scrolling-checkerboard__bullet')
                            .not(`:nth-child(${response.index + 1})`)
                            .removeClass('state-active');
                    }
                });
                checkerboardSteps.forEach((step, i) => {
                    step.classList.remove('is-active');
                    if (i === response.index) {
                        step.classList.add('is-active');
                    }
                });
            };

            const initDestroyCheck = () => {
                const mediaQuery = window.matchMedia('(max-width: 1023px)');
                if (mediaQuery.matches) {
                    if (window.hasOwnProperty(`scroller${i}`)) {
                        window['scroller' + i].destroy();
                    }
                    bullets.innerHTML = '';
                } else {
                    if (!bullets.hasChildNodes()) {
                        checkerboardSteps.forEach((step) => {
                            let bullet = document.createElement('div');
                            bullet.classList.add('cl-scrolling-checkerboard__bullet');
                            bullets.append(bullet);
                        });
                    }

                    window['scroller' + i] = scrollama();
                    window['scroller' + i]
                        .setup({
                            step: '.cl-scrolling-checkerboard .cl-scrolling-checkerboard__text .cl-scrolling-checkerboard__step-wrap',
                            offset: 0.33,
                            debug: false,
                        })
                        .onStepEnter(handleStepEnter);
                    handleResize();
                }
            };

            window.addEventListener(
                'resize',
                throttle(1000, () => {
                    initDestroyCheck();
                })
            );

            initDestroyCheck();
        });
    },

    init: () => {
        scrollingCheckerboard.setupScrollingCheckerboard();
    },
};

if (document.readyState === 'loading') {
    // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', scrollingCheckerboard.init);
} else {
    // `DOMContentLoaded` has already fired
    scrollingCheckerboard.init();
}
